/**
 * Data modules
 */
export * from './manager';
export * from './query';
export * from './adaptors';
export * from './util';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-data/src/index.js
// module id = 1862
// module chunks = 0